// Module
var code = `<div class="svc-surface-placeholder">
  <div class="svc-surface-placeholder__image" data-bind="css: 'svc-surface-placeholder__image--' + \$data.name"></div>
  <div class="svc-surface-placeholder__text">
    <div class="svc-surface-placeholder__title" data-bind="text: \$data.placeholderTitleText"></div>
    <div class="svc-surface-placeholder__description" data-bind="text: \$data.placeholderDescriptionText"></div>
  </div>
</div>`;
// Exports
export default code;